import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["hm0_output"];
  connect() {
    super.connect();
    console.log("Bons de Commandes controller js en cours ..");
  }
}
